import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function durationValidators(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const hours = control.get('hours')?.value;
    const minutes = control.get('minutes')?.value;

    // Convertir en nombres, gérer les chaînes vides ou null
    const hoursNum = Number(hours);
    const minutesNum = Number(minutes);

    // Vérifier si au moins un est positif
    const isValid =
      (!isNaN(hoursNum) && hoursNum > 0) ||
      (!isNaN(minutesNum) && minutesNum > 0);

    return isValid
      ? null
      : {
          durationInvalid: true,
        };
  };
}
